import {
  Modal,
  ModalOverlay,
  ModalContent,
  Text,
  ModalCloseButton,
  ModalBody,
  Heading,
  List,
  ListItem,
  Box,
} from '@chakra-ui/react'
import { Image } from '@/components/HOC/Image'
import CoinflipChallange from '@/public/assets/images/coinflip/wizzard-lottery.jpg'

export const CoinflipContestModal = ({ onClose }: { onClose: () => void }) => {
  return (
    <Modal size={'lg'} isOpen={true} onClose={onClose}>
      <ModalOverlay />
      <ModalContent marginLeft={2.5} marginRight={2.5}>
        <ModalCloseButton onClick={onClose} size="sm" />
        <ModalBody pb={5} pt={10}>
          <CoinflipContest />
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

const CoinflipContest = () => {
  return (
    <Box userSelect={'none'} fontSize={'sm'} color={'ninja.100'}>
      <Image mb={4} rounded={'2xl'} src={CoinflipChallange} alt="" />
      <Heading userSelect={'none'} fontSize={'32px'} mb={2}>
        Coinflip Lottery
      </Heading>
      <Text fontWeight={500} mb={2}>
        Every $NBZ Token Bet is a Ticket! Prize pool is 25 $INJ!
      </Text>
      <Text userSelect={'none'} fontWeight={700} fontSize={'sm'} color={'ninja.100'} mb={1}>
        Rules:
      </Text>
      <List mb={2} fontWeight={500}>
        <ListItem>1. For every 1 $NBZ token bet, you receive 1 lottery ticket.</ListItem>
        <ListItem>2. The more you bet, the higher your chances of winning.</ListItem>
        <ListItem>3. The lottery starts at the 56,000th game and ends at the 100,000th.</ListItem>
        <ListItem>4. A random drawing will determine 5 winners who will each receive 5 $INJ!</ListItem>
      </List>
      <Text fontStyle={'italic'} userSelect={'none'} fontWeight={500} fontSize={'sm'} color={'ninja.100'}>
        Good luck!
      </Text>
    </Box>
  )
}
